<template>
    <div>
        <h2>{{ $t("settings.smart-routing.templates.header") }}</h2>
        <p>
            {{ $t("settings.smart-routing.templates.explainer") }}
        </p>

        <b-form-group
            id="fieldset-template"
            :description="$t('settings.smart-routing.templates.template.description')"
            :label="$t('settings.smart-routing.templates.template.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="template"
        >
            <div class="d-flex flex-row">
                <b-form-select
                    id="afterTemplate"
                    v-model="currentRoute.afterTemplate"
                    :options="templates"
                    :state="selectedTemplateIsValid ? null : false"
                    text-field="title"
                    value-field="id"
                />
                <font-awesome-icon
                    v-b-tooltip.hover.top="selectedTemplateContent"
                    :icon="['fas', 'eye']"
                    class="cursor-pointer m-1"
                />
            </div>
        </b-form-group>
    </div>
</template>
<script>
import { BFormGroup, BFormSelect, BInputGroup, VBTooltip } from "bootstrap-vue";
import { computed, watch } from "@vue/composition-api";
import i18n from "@/libs/i18n";
import useRoutes from "@/views/modules/settings/smart-routing/useRoutes";

export default {
    components: {
        BFormGroup,
        BFormSelect,
        BInputGroup,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const { currentRoute, fetchTemplatesForChannel, templates, selectedTemplateIsValid } = useRoutes();
        const selectedTemplateContent = computed(() => {
            if (!currentRoute.value.afterTemplate) {
                return "";
            }
            return templates.value?.find((template) => template.id === currentRoute.value.afterTemplate)?.content || "";
        });

        watch(
            () => currentRoute.value.channelId,
            (newChannelId, oldChannelId) => {
                if (newChannelId && newChannelId !== oldChannelId) {
                    // Get all templates that are part of this channel
                    fetchTemplatesForChannel(newChannelId).then(() => {
                        // If the selected template is not present in the new channel remove the selected template
                        if (
                            !templates.value.includes((template) => template.value === currentRoute.value.afterTemplate)
                        ) {
                            currentRoute.value.templateId = null;
                        }
                    });
                } else if (!newChannelId) {
                    currentRoute.value.afterTemplate = null;
                    templates.value = [
                        {
                            id: null,
                            title: i18n.t("settings.smart-routing.templates.template.none"),
                        },
                    ];
                }
            }
        );

        if (currentRoute.value.channelId) {
            fetchTemplatesForChannel(currentRoute.value.channelId);
        }

        // This is so none is selected by default in the dropdown. undefined & null are not the same
        if (!currentRoute.value.afterTemplate) {
            currentRoute.value.afterTemplate = null;
        }

        return {
            templates,
            selectedTemplateContent,
            currentRoute,
            selectedTemplateIsValid,
        };
    },
};
</script>
